import React from 'react';
import { DLSSize } from 'src/types/dls-size.enum';
import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';
import { IconCheck } from '@americanexpress/dls-icons';

export interface ApplyButtonProps {
    secondary?: boolean;
    showText?: boolean;
    showIcon?: boolean;
    'aria-label'?: string;
    'data-cy'?: string;
    className?: string;
}

export default function ApplyButton({
    secondary,
    showText,
    showIcon,
    'aria-label': ariaLabel,
    'data-cy': dataCy,
    className
}: ApplyButtonProps): JSX.Element {
    const ButtonComponent: typeof ButtonPrimary | typeof ButtonSecondary = secondary ? ButtonSecondary : ButtonPrimary;

    return (
        <ButtonComponent
            size={DLSSize.MEDIUM}
            icon={showIcon ? <IconCheck /> : undefined}
            aria-label={ariaLabel}
            data-cy={dataCy}
            className={className}
            type="submit"
        >
            {showText && 'Apply'}
        </ButtonComponent>
    );
}
